import React, { useContext, useState } from "react";

// Custom.
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import EditDialog from "@vocollege/components/dist/EditDialog";
import { ParticipantsProps } from "../global";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import VoApi from "@vocollege/app/dist/modules/VoApi";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_PARTICIPANTS, DELETE_PARTICIPANT, GET_COURSE_MOMENTS } from "api";
import ParticipantForm from "../ParticipantForm/ParticipantForm";
import { useStyles } from "./styles";
import { VoAppContext } from "services/GlobalState";

const Participants: React.FC<ParticipantsProps> = (props) => {
  const {
    dialog,
    dialogProps = { open: false },
    onCancel,
    courseMoment,
  } = props;
  const [selectedParticipant, setSelectedParticipant] = useState<any>(null);
  const classes = useStyles();
  const { dispatch } = useContext<any>(VoAppContext);

  // Methods.

  const getDialogTitle = () => {
    if (!courseMoment) {
      return I18n.get.participant.labels.participants;
    }
    return I18n.trans(I18n.get.participant.labels.participantsInCourseMoment, {
      courseMoment: courseMoment.title,
    });
  };

  const editItem = (id = "skapa", row = {}) => {
    setSelectedParticipant({ id, ...row });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_participants", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_participants", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const handleComplete = async (data: any) => {
    dispatch({
      key: "loading",
      values: "updateParticipants",
    });
    setSelectedParticipant(null);
    await refetchQueries();
    dispatch({
      key: "loading",
      values: "updateParticipants",
    });
  };

  const handleDelete = async (data: any) => {
    await refetchQueries();
  };

  const refetchQueries = async () => {
    await VoApi.graphqlClient.refetchQueries({
      include: [GET_COURSE_MOMENTS, GET_PARTICIPANTS],
    });
  };

  const getContent = () => {
    return (
      <EnhancedTable
        // className="vo-global__top-bottom-space"
        classes={{ paper: classes.tablePaper }}
        title={!dialog ? I18n.get.participant.labels.participants : undefined}
        operations={{
          category: "certParticipants",
          get: GET_PARTICIPANTS,
          delete: DELETE_PARTICIPANT,
        }}
        labels={{
          deleted: I18n.get.participant.messages.participantDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.user.labels.firstname, field: "firstname" },
          { title: I18n.get.user.labels.lastname, field: "lastname" },
          { title: I18n.get.user.labels.town, field: "town" },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={
          VoAuth.ability.can("create_own_participants", "Cert")
            ? editItem
            : undefined
        }
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        actionButtons={getActionButtons()}
        queryVariables={{ courseMoment: courseMoment?.id }}
        onDelete={handleDelete}
      />
    );
  };

  return (
    <>
      {dialog && (
        <EditDialog
          {...dialogProps}
          disableActions
          // disableCloseButton
          className={classes.dialog}
          title={getDialogTitle()}
          onCancel={onCancel}
        >
          {getContent()}
        </EditDialog>
      )}
      {!dialog && <Layout>{getContent()}</Layout>}
      {!!selectedParticipant && (
        <ParticipantForm
          dialog
          dialogProps={{ open: !!selectedParticipant }}
          urlParams={{ id: selectedParticipant && selectedParticipant.id }}
          onComplete={handleComplete}
          onCancel={() => setSelectedParticipant(null)}
          courseMoment={courseMoment}
        />
      )}
    </>
  );
};

export default Participants;
